module.exports = __webpack_public_path__ + "img/banner.6dc30ce8.png";